module.exports = __webpack_public_path__ + "static/media/Illus-BowlEmpty@3x.c074bb0d.png";